export enum ClaimStatus {
  Available = 'Available',
  Complete = 'Complete',
  Pending = 'Pending',
}
